import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, inject } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { LoyaltyProgramProductTerms } from '@src/app/modules/loyalty-program/models';
import { LoyaltyProgramPermService } from '@src/app/modules/loyalty-program/services';

@Component({
  selector: 'lp-view-discount-group-row',
  templateUrl: './discount-group-row.component.html',
  styleUrls: ['./discount-group-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscountGroupRowComponent extends BaseResizableComponent {
  private readonly permService = inject(LoyaltyProgramPermService);

  @Input() discountGroup?: LoyaltyProgramProductTerms;
  @Input() isUserOrganisation = false;
  @Input() isUserAssociation = false;
  @Input() productUnionId?: string;
  @Output() getDiscount = new EventEmitter<string | undefined>();

  get allowedProductCodesExport() {
    return (
      this.discountGroup?.isPermanentCode === false &&
      ((this.permService.allowedProductCodesExport && this.isUserAssociation) ||
        (this.permService.allowedOnlyYourOrganisationProductCodesExport && this.isUserOrganisation))
    );
  }
}
